<template>
  <v-card>
    <v-toolbar color="indigo" dense>
      <v-toolbar-title class="white--text">Selezione commesse</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            @click="dialog_conferma_salva = true"
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="success"> mdi-floppy </v-icon>
          </v-btn>
        </template>
        <span>Salva</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-if="filtri_visible === false">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="filtri_visible = true"
            small
            v-bind="attrs"
            v-on="on"
            ><v-icon color="purple lighten-2">mdi-filter</v-icon></v-btn
          >
        </template>
        <span>Filtri</span>
      </v-tooltip>
      <v-tooltip bottom v-else>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mr-5"
            @click="
              filtri_visible = false;
              cod_articolo_sel = '';
              stato_sched_sel = '';
              stato_commessa = '';
              filtra();
            "
            small
            v-bind="attrs"
            v-on="on"
          >
            <v-icon color="purple lighten-2">mdi-filter-off</v-icon>
          </v-btn>
        </template>
        <span>Ripristina</span>
      </v-tooltip>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn @click="clickIndietro" small v-bind="attrs" v-on="on">
            <v-icon color="error"> mdi-close </v-icon>
          </v-btn>
        </template>
        <span>Chiudi</span>
      </v-tooltip>
    </v-toolbar>
    <v-row v-if="filtri_visible === true" align="center" justify="center">
      <v-col cols="3">
        <v-text-field
          background-color="#ffffff"
          @change="filtra"
          hide-details
          label="Codice Articolo"
          style="display: inline-block; max-width: 350px"
          v-model="cod_articolo_sel"
        >
          <template v-slot:append>
            <v-icon
              class="ml-2"
              @click="
                cod_articolo_sel = '';
                filtra();
              "
              color="primary"
              >{{
                cod_articolo_sel == "" ? "mdi-filter" : "mdi-filter-off"
              }}</v-icon
            >
          </template></v-text-field
        >
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          background-color="#ffffff"
          @change="filtra"
          hide-details
          :items="items"
          :item-text="(e) => e.cod"
          item-value="des"
          label="Commessa"
          style="display: inline-block; max-width: 350px"
          v-model="commessa"
        >
          <template v-slot:append>
            <v-icon
              class="ml-2"
              @click="
                commessa = '';
                filtra();
              "
              color="primary"
              >{{ commessa == "" ? "mdi-filter" : "mdi-filter-off" }}</v-icon
            >
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="3">
        <v-autocomplete
          background-color="#ffffff"
          @change="filtra"
          hide-details
          :items="items"
          :item-text="(e) => e.stato_schedulatore"
          item-value="des"
          label="Stato schedulazione"
          style="display: inline-block; max-width: 350px"
          v-model="stato_sched_sel"
        >
          <template v-slot:append>
            <v-icon
              class="ml-2"
              @click="
                stato_sched_sel = '';
                filtra();
              "
              color="primary"
              >{{
                stato_sched_sel == "" ? "mdi-filter" : "mdi-filter-off"
              }}</v-icon
            >
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-card-text style="overflow-y: auto">
      <v-data-table
        height="60vh"
        fixed-header
        :headers="headers"
        :items="items_visualizzati"
      >
        <!-- Colonna dello stato -->

        <template v-slot:[`item.des_stato`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                large
                v-if="item.des_stato == 'Sospesa'"
                color="primary"
                v-bind="attrs"
                v-on="on"
                >mdi-pause-circle</v-icon
              >
              <v-icon
                large
                v-else-if="item.des_stato == 'Aperta'"
                color="orange"
                v-bind="attrs"
                v-on="on"
                >mdi-play-speed</v-icon
              >
              <v-icon
                large
                v-else-if="item.des_stato == 'Creata'"
                color="success"
                v-bind="attrs"
                v-on="on"
                >mdi-check-circle</v-icon
              >
            </template>
            <span>{{ item.des_stato }}</span>
          </v-tooltip>
        </template>

        <!-- Colonna dello stato schedulazione -->
        <template v-slot:[`item.stato_schedulatore`]="{ item }">
          <v-icon
            class="pl-4"
            large
            v-if="item.stato_schedulatore == 'Schedulato'"
            color="success"
            >mdi-check</v-icon
          >
        </template>

        <!-- Colonna della stima della schedulazione -->
        <template v-slot:[`item.stima_tempo`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-container
                v-bind="attrs"
                v-on="on"
                v-show="
                  item.stato_schedulatore == 'Non schedulato' &&
                  item.stima_tempo >= 5
                "
              >
                <v-icon small color="primary">circle</v-icon
                ><v-icon small color="primary">circle</v-icon
                ><v-icon small color="primary">circle</v-icon
                ><v-icon small color="primary">circle</v-icon>
              </v-container>
            </template>
            <span>Più di 5 minuti</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-container
                v-bind="attrs"
                v-on="on"
                v-show="
                  item.stato_schedulatore == 'Non schedulato' &&
                  item.stima_tempo > 1 &&
                  item.stima_tempo < 5
                "
              >
                <v-icon small color="primary">circle</v-icon
                ><v-icon small color="primary">circle</v-icon
                ><v-icon small color="primary">circle</v-icon
                ><v-icon small color="primary">mdi-circle-outline</v-icon>
              </v-container>
            </template>
            <span>Tra 1 minuto e 5 minuti</span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-container
                v-bind="attrs"
                v-on="on"
                v-show="
                  item.stato_schedulatore == 'Non schedulato' &&
                  item.stima_tempo <= 1 &&
                  item.stima_tempo > 0.5
                "
              >
                <v-icon small color="primary">circle</v-icon
                ><v-icon small color="primary">circle</v-icon
                ><v-icon small color="primary">mdi-circle-outline</v-icon
                ><v-icon small color="primary">mdi-circle-outline</v-icon>
              </v-container></template
            ><span>Tra 30 secondi e 1 minuto</span></v-tooltip
          >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-container
                v-bind="attrs"
                v-on="on"
                v-show="
                  item.stato_schedulatore == 'Non schedulato' &&
                  item.stima_tempo <= 0.5 &&
                  item.stima_tempo != null
                "
              >
                <v-icon small color="primary">circle</v-icon
                ><v-icon small color="primary">mdi-circle-outline</v-icon
                ><v-icon small color="primary">mdi-circle-outline</v-icon
                ><v-icon small color="primary">mdi-circle-outline</v-icon>
              </v-container></template
            ><span>Meno di 30 secondi</span></v-tooltip
          >
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-show="
                  item.stato_schedulatore == 'Non schedulato' &&
                  item.stima_tempo == null
                "
                class="pl-7"
                v-bind="attrs"
                v-on="on"
                color="orange"
                align="center"
                >mdi-help-circle</v-icon
              > </template
            ><span>Non disponibile</span></v-tooltip
          >
        </template>

        <!-- Colonna della selezione -->
        <template v-slot:[`item.seleziona`]="{ item }">
          <v-simple-checkbox
            style="left: 12px"
            v-if="
              item.stato_schedulatore == 'Non schedulato' && item.errori == null
            "
            color="primary"
            v-model="item.selezionato"
          ></v-simple-checkbox>
          <v-btn
            v-else-if="
              item.errori != null && item.stato_schedulatore == 'Non schedulato'
            "
            @click="
              dialog_errori = true;
              errori = JSON.parse(item.errori);
              stato_comm = item.des_stato;
            "
            small
            ><v-icon color="orange">mdi-exclamation-thick</v-icon></v-btn
          >
        </template>
        <!-- Colonna del modifica -->
        <template v-slot:[`item.modifica`]="{ item }">
          <v-btn
            @click="
              apri_modifica_commessa = true;
              commessa_modif = item.id_commessa;
              key_commessa_dashboard = key_commessa_dashboard === 0 ? 1 : 2;
            "
            small
            ><v-icon color="primary">mdi-pencil</v-icon></v-btn
          >
        </template>
        <!-- Colonna della scelta colore -->
        <template v-slot:[`item.scegli_col`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                small
                v-show="item.stato_schedulatore == 'Non schedulato'"
                @click="
                  mostra_colori_sel == item.id_commessa
                    ? (mostra_colori_sel = '')
                    : (mostra_colori_sel = item.id_commessa)
                "
                v-bind="attrs"
                v-on="on"
              >
                <v-icon
                  :color="item.colore_sfondo ? item.colore_sfondo : 'primary'"
                >
                  mdi-palette
                </v-icon>
              </v-btn>
            </template>
            <span>Colori sfondo e testo</span>
          </v-tooltip>
          <v-color-picker
            v-show="mostra_colori_sel == item.id_commessa"
            @update:color="
              item.colore_sfondo
                ? item.colore_sfondo.hex
                  ? (item.colore_sfondo = item.colore_sfondo.hex)
                  : '#000000'
                : '#000000'
            "
            v-model="item.colore_sfondo"
            class="ma-2"
            dark
            hide-canvas
            hide-inputs
            hide-sliders
            hide-mode-switch
            :swatches="swatches"
            show-swatches
          ></v-color-picker>

          <v-color-picker
            v-show="mostra_colori_sel == item.id_commessa"
            @update:color="
              item.colore_testo
                ? item.colore_testo.hex
                  ? (item.colore_testo = item.colore_testo.hex)
                  : '#000000'
                : '#000000'
            "
            v-model="item.colore_testo"
            class="ma-2"
            hide-canvas
            dark
            hide-inputs
            hide-sliders
            hide-mode-switch
            :swatches="swatches_text"
            show-swatches
          ></v-color-picker>

          <!-- {{ item.colore_testo }} - {{ item.colore_sfondo }} -->
        </template>
        <!-- Colonna del delete -->
        <template v-slot:[`item.delete`]="{ item }">
          <v-btn
            @click="
              dialog_conferma_elimina = true;
              id_eliminazione = item.id_commessa;
            "
            small
            v-if="item.stato_schedulatore == 'Schedulato'"
            v-model="item.cancellato"
            ><v-icon color="error">mdi-delete</v-icon></v-btn
          >
        </template>
        <!-- Colonna del metodo di schedulazione -->
        <template v-slot:[`item.metodo`]="{ item }">
          <div :key="key_tabella">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="
                    item.metodo = 'Forward';
                    key_tabella = key_tabella == 2 ? 3 : 2;
                  "
                  x-small
                  v-show="
                    item.stato_schedulatore == 'Non schedulato' &&
                    item.metodo == 'Backward'
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon :key="item.metodo" color="primary"
                    >mdi-arrow-left-thin
                  </v-icon>
                </v-btn></template
              >
              <span>Backward</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="
                    item.metodo = 'Backward';
                    key_tabella = key_tabella == 2 ? 3 : 2;
                  "
                  x-small
                  v-show="
                    item.stato_schedulatore == 'Non schedulato' &&
                    item.metodo == 'Forward'
                  "
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon :key="item.metodo" color="primary"
                    >mdi-arrow-right-thin</v-icon
                  >
                </v-btn>
              </template>
              <span>Forward</span>
            </v-tooltip>
          </div>
        </template>
      </v-data-table>
    </v-card-text>

    <v-overlay
      color="rgba(0, 0, 0, 1)"
      style="position: absolute"
      :value="caricamento_dati"
    >
      <v-icon class="ConsuntivoWORuota" size="100">mdi-cog</v-icon>
      <v-icon class="ConsuntivoWOControruota" size="100">mdi-cogs</v-icon>
    </v-overlay>

    <!-- Snackbar -->
    <SnackbarQV ref="SnackbarQV" />
    <!-- DIALOG CONFERMA SALVATAGGIO -->
    <v-dialog v-model="dialog_conferma_salva" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Salva</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di salvataggio -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="salva" small v-bind="attrs" v-on="on">
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_salva = false"
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="error"> mdi-close </v-icon>
              </v-btn>
            </template>
            <span>Annulla</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h2 class="mt-5">
            Clicca salva per schedulare le commesse selezionate.
          </h2>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG CONFERMA ELIMINAZIONE -->
    <v-dialog v-model="dialog_conferma_elimina" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1"
          dense
        >
          <v-toolbar-title>Eliminazione</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di conferma -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  deleteSched(id_eliminazione);
                  dialog_conferma_elimina = false;
                "
                small
                v-bind="attrs"
                v-on="on"
              >
                <v-icon color="success"> mdi-floppy </v-icon>
              </v-btn>
            </template>
            <span>Conferma</span>
          </v-tooltip>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="dialog_conferma_elimina = false"
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mt-5 mb-0 pb-5">
          <h2 class="mt-5">
            Clicca salva per cancellare la schedulazione selezionata in maniera
            irreversibile.<br />I dati cancellati in maniera irreversibile non
            potranno più essere recuperati.
          </h2>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG CON ERRORI -->
    <v-dialog v-model="dialog_errori" width="unset">
      <v-card>
        <v-toolbar
          class="white--text"
          color="indigo"
          style="position: sticky; top: 0px; z-index: 1; min-width: 500px"
          dense
        >
          <v-toolbar-title>Commessa non schedulabile</v-toolbar-title>
          <v-spacer></v-spacer>
          <!-- Bottone di chiusura -->
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                @click="
                  dialog_errori = false;
                  errori = [];
                  stato_comm = '';
                "
                small
                v-bind="attrs"
                v-on="on"
                ><v-icon color="error">mdi-close</v-icon></v-btn
              >
            </template>
            <span>Chiudi</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text class="mr-5">
          <!--  {{errori}} -->
          <h3 class="mt-5">
            <ul id="example-1">
              <li style="text-align: left" v-if="stato_comm == 'Sospesa'">
                La commessa è sospesa
              </li>
              <li
                v-for="(errore, index) in errori"
                :key="index"
                style="text-align: left"
              >
                Errore {{ errore.cod_errore }} - {{ errore.des_errore }}
                {{ errore.macchina }}
              </li>
            </ul>
          </h3>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- DIALOG MODIFICA COMMESSA -->
    <v-dialog v-model="apri_modifica_commessa">
      <CommesaDashBoard
        class="ma-0 pa-0"
        @click_chiudi_dettaglio="
          apri_modifica_commessa = null;
          commessa_modif = -1;
        "
        @salvataggio_effettuato="getWorkOrders"
        :key="key_commessa_dashboard"
        :id_commessa="commessa_modif"
        :componente_interno="true"
      />
    </v-dialog>
  </v-card>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import CommesaDashBoard from "@/views/PRODUCTION/Commesa/CommesaDashBoard.vue";

export default {
  name: "",
  components: { SnackbarQV, CommesaDashBoard },
  props: {
    visible: { type: Boolean, default: false },
    dropDB: {
      type: Function,
      default: () => {},
    },
    metodo_default: { type: String, default: "Forward" },
  },
  data() {
    return {
      // Variabili d'appoggio
      // Modal
      caricamento_dati: false,
      mostra_colori_sel: "",
      cod_articolo_sel: "",
      cod_commessa_sel: "",
      key_commessa_dashboard: 0,
      stato_sched_sel: "",
      lavorazione_sel: null,
      commessa: "",
      dialog_errori: false,
      stato_comm: "",
      errori: [],
      items: [],
      items_visualizzati: [],
      key_tabella: 2,
      ricarica_pagina: false,
      //page_count: null,
      filtri_visible: false,
      dialog_conferma_salva: false,
      dialog_conferma_elimina: false,
      apri_modifica_commessa: false,
      id_eliminazione: "",
      commessa_modif: -1,
      swatches: [
        ["#C2EDF9", "#93EB74"],
        ["#FFB7B2", "#FFDAC1"],
        ["#E2F0CB", "#FAEE67"],
      ],
      swatches_text: [
        ["#000000", "#FF0000"],
        ["#199C1A", "#005500"],
        ["#0000FF", "#000055"],
      ],

      // Array
      headers: [],
      work_orders: new Array(),
      work_orders_totali: new Array(),
    };
  },
  computed: {},
  watch: {
    visible: {
      immediate: true,
      handler() {
        if (this.visible === true) {
          this.getWorkOrders();
        }
      },
    },
    items: {
      immediate: true,
      handler() {
        this.items_visualizzati = this.items;
        this.filtra();
      },
    },
  },
  methods: {
    clickIndietro() {
      this.$emit("click_chiudi");
      if (this.ricarica_pagina == true) {
        document.location.reload(true);
      }
    },

    filtra() {
      console.log("filtra");
      let items_wo_tmp = [];
      this.items.forEach((elem) => {
        items_wo_tmp.push(elem);
      });

      // Filtro il codice articolo
      if (this.cod_articolo_sel != "") {
        let res = [];

        items_wo_tmp.forEach((elem) => {
          if (
            elem.cod_articolo
              .toUpperCase()
              .includes(this.cod_articolo_sel.toUpperCase())
          ) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      // Filtro lo stato schedulazione
      if (this.stato_sched_sel != "") {
        let res = [];

        items_wo_tmp.forEach((elem) => {
          if (elem.stato_schedulatore == this.stato_sched_sel) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      // Filtro lo stato commessa
      if (this.commessa != "") {
        let res = [];

        items_wo_tmp.forEach((elem) => {
          if (elem.cod == this.commessa) {
            res.push(elem);
          }
        });

        items_wo_tmp = res;
      }

      this.items_visualizzati = [];
      this.items_visualizzati = items_wo_tmp;
      this.items_visualizzati.sort(
        (a, b) => parseFloat(a.cod_fase) - parseFloat(b.cod_fase)
      );
    },
    getWorkOrders() {
      this.caricamento_dati = true;

      let request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "getcommessa",
          token: localStorage.getItem("user_token"),
          /*  cod_commessa: "",
          filtroEM: "", */
        },
      };

      this.$store.dispatch("api", request).then((res) => {
        this.caricamento_dati = false;
        this.items = res.data.lista;
        this.items.forEach((item) => {
          if (item.stato_schedulatore == null) {
            item.metodo = this.metodo_default;
          }
          //console.log(item.metodo);
        });

        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].stato_schedulatore != null) {
            this.items[i].stato_schedulatore = "Schedulato";
          } else {
            this.items[i].stato_schedulatore = "Non schedulato";
          }
        }

        for (let i = 0; i < this.items.length; i++) {
          let number = this.items[i].qta;
          this.items[i].qta = number.toLocaleString("de-DE");
        }

        let del = {
          value: "delete",
          text: "Cancella",
          sortable: false,
        };

        let metodo = {
          value: "metodo",
          text: "Metodo",
          sortable: false,
        };

        let edit_stato = {
          text: "Selezione",
          sortable: false,
          value: "seleziona",
          class: "",
        };

        let color_picker = {
          text: "Colore",
          sortable: false,
          value: "scegli_col",
          class: "",
        };

        let modifica = {
          text: "Modifica",
          sortable: false,
          value: "modifica",
          class: "",
        };

        if (res.data.header != undefined) {
          this.headers = res.data.header;
          this.headers.forEach((elem) => {
            elem.sortable = true;
          });

          let indice_elim = null;
          for (let i = 0; i < this.headers.length; i++) {
            if (this.headers[i].value == "qta") {
              this.headers[i].sortable = false;
            }
            if (this.headers[i].value == "stima_tempo") {
              this.headers[i].visible = 1;
              this.headers[i].text = "Attesa sched.";
            }
            if (this.headers[i].value == "stato_schedulatore") {
              this.headers[i].text = "Schedulato";
            }
            if (this.headers[i].value == "des_padre") {
              indice_elim = i;
              this.headers.splice(indice_elim, 1); //commessa padre
            }

            if (this.headers[i].value == "colore_testo") {
              indice_elim = i;
              this.headers.splice(indice_elim, 1);
            }

            if (this.headers[i].value == "colore_sfondo") {
              indice_elim = i;
              this.headers.splice(indice_elim, 1);
            }
          }

          this.headers.push(del);
          this.headers.unshift(metodo);
          this.headers.unshift(color_picker);
          this.headers.unshift(modifica);
          this.headers.unshift(edit_stato);
          for (let i = 0; i < this.headers.length; i++) {
            console.log(this.headers[i].text);
          }
        }
      });
    },

    salva() {
      const arr_tmp = new Array();
      this.items.forEach((w) => {
        if (w.selezionato === true) {
          let commessa = {
            id_commessa: w.id_commessa,
            colore_testo: w.colore_testo,
            colore_sfondo: w.colore_sfondo,
            metodo: w.metodo,
          };
          arr_tmp.push(commessa);
        }
      });

      const request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "schedulazione",
          token: localStorage.user_token,
          commesse: arr_tmp,
        },
      };

      // Inserisco un overlay di caricamento.
      (this.dialog_conferma_salva = false), (this.caricamento_dati = true);

      this.$store
        .dispatch("api", request)
        .then((res) => {
          // Tolgo l'overlay di caricamento.
          this.caricamento_dati = false;

          if (res.status === 200) {
            this.dropDB();
            this.$emit("inviati_wo");

            // Stampo una snackbar di conferma.
            this.$refs.SnackbarQV.print("success", "Schedulazione effettuata.");
            document.location.reload(true);
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              "Errore di comunicazione col server, non è stato possibile caricare i dati."
            );
          }
        })
        .catch((err) => {
          // Tolgo l'overlay di caricamento.
          this.caricamento_dati = false;

          // Stampo una snackbar di avviso.
          this.$refs.SnackbarQV.print(
            "error",
            "Errore di comunicazione col server, non è stato possibile caricare i dati."
          );

          // Stampo il log dell'errore in console.
          console.error(err);
        });
    },

    deleteSched(arg) {
      var request = {
        controller: "Schedulatore",
        method: "POST",
        richiesta: {
          action: "cancella",
          token: localStorage.getItem("user_token"),
          id_commessa: arg,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status == 200) {
            console.log("Elemento eliminato");
            this.dropDB();
            this.getWorkOrders();
            this.ricarica_pagina = true;
          }
        })
        .catch((err) => {
          console.log("ERRORE");
          console.log(err);
        });
      this.id_eliminazione = "";
    },
  },

  created() {},
  mounted() {},
};
</script>
<style scoped>
@keyframes ConsuntivoWOControtazione {
  0% {
    transform: rotate(360deg);
  }
  100% {
    transform: rotate(0deg);
  }
}
@keyframes ConsuntivoWORotazione {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.ConsuntivoWOControruota {
  animation: ConsuntivoWOControtazione 1s infinite;
  animation-timing-function: linear;
}

.ConsuntivoWORuota {
  animation: ConsuntivoWORotazione 1s infinite;
  animation-timing-function: linear;
}
</style>